module.exports = __webpack_public_path__ + "static/media/Help.d9d22e97.pdf";